/** Beside a "—" for a hands-won total that includes a historical session with no known count. */
export const HANDS_WON_UNAVAILABLE = 'Some historical hands-won results are unavailable.';
